// @flow

export { CustomerFields } from './customer-fields';
